/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'doT',
	'text!./templates/AnalyticsColorSet.html'
], (dot, templateString) => {
	class AnalyticsColorSet {
		static getColorStyles(colorService, paletteId) {
			return colorService.getForegroundCSSColors('DataWidgetFilterColor1UserPaletteColor', paletteId).then((dataWidgetFilterColor1UserPaletteColor) => {
				return AnalyticsColorSet.dotTemplate({
					colors: colorService.getColorSet(paletteId),
					dataWidgetFilterColor1UserPaletteColor: dataWidgetFilterColor1UserPaletteColor
				});
			});
		}
	}

	AnalyticsColorSet.dotTemplate = dot.template(templateString);

	return AnalyticsColorSet;
});
